import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
export default function AboutAccess() {
  return <section id="about-access" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">

        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground font-default leading-tight mb-4">アクセス</h2>
          <Separator className="w-12 h-0.5 bg-primary" />
        </div>

        <address className="not-italic">
          <p className="text-xl font-bold text-foreground font-default mb-6">新宿四谷心理カウンセリングルーム</p>
          <dl className="border-y border-border divide-y divide-border">
            <div className="grid grid-cols-[6rem_1fr] gap-4 py-4">
              <dt className="text-sm text-muted-foreground font-default">住所</dt>
              <dd className="text-foreground leading-relaxed font-default">〒160-0006 東京都新宿区舟町4-1 メゾンド四谷303号室</dd>
            </div>
            <div className="grid grid-cols-[6rem_1fr] gap-4 py-4">
              <dt className="text-sm text-muted-foreground font-default">交通アクセス</dt>
              <dd className="text-foreground leading-relaxed font-default">東京メトロ丸ノ内線「四谷三丁目駅」より徒歩約4分<br />都営新宿線「曙橋駅」より徒歩約7分</dd>
            </div>
            <div className="grid grid-cols-[6rem_1fr] gap-4 py-4">
              <dt className="text-sm text-muted-foreground font-default">電話番号</dt>
              <dd className="text-foreground font-bold font-default"><Link to="tel:080-9553-8244" className="hover:text-primary-heading transition-colors">080-9553-8244</Link></dd>
            </div>
            <div className="grid grid-cols-[6rem_1fr] gap-4 py-4">
              <dt className="text-sm text-muted-foreground font-default">開室時間</dt>
              <dd className="text-foreground font-default">10:00〜21:00</dd>
            </div>
            <div className="grid grid-cols-[6rem_1fr] gap-4 py-4">
              <dt className="text-sm text-muted-foreground font-default">定休日</dt>
              <dd className="text-foreground font-default">不定休</dd>
            </div>
          </dl>
        </address>

        <p className="mt-8 text-foreground leading-relaxed font-default">四谷・曙橋エリアで対面のカウンセリングを行っているほか、オンラインでのご相談にも対応しています。ご予約は<Link to="https://yotsuya-sc-room.com/reserve/" className="text-primary-heading underline underline-offset-4">お問い合わせフォーム</Link>またはお電話から承ります。</p>

      </div>
    </section>;
}